import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UtilityService } from '../../core/services/utility/utility.service';
import { NgIf } from '@angular/common';
import { ScopePatternLeftNavigationPaneComponent } from './scope-pattern-left-navigation-pane/scope-pattern-left-navigation-pane.component';
import { RouterOutlet } from '@angular/router';
export interface IMedia {
  title: string;
  src: string;
  type: string;
}

@Component({
    selector: 'app-scope-pattern',
    templateUrl: './scope-pattern.component.html',
    styleUrls: ['./scope-pattern.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        ScopePatternLeftNavigationPaneComponent,
        RouterOutlet,
    ],
})
export class ScopePatternComponent implements OnInit {

  public screenWidth: number;
  
  constructor(private utilityService: UtilityService) {
    this.screenWidth = this.utilityService.getScreenWidth();
   }

  ngOnInit() {
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

}
